module.exports = __webpack_public_path__ + "static/media/solo_hymen2.a3b0d0d0.svg";